import { defineStyle } from '@chakra-ui/react';

export const defaultVariant = defineStyle({
  background: 'neutral.900',
  color: 'neutral.white',
  border: '2px solid',
  borderColor: 'neutral.black',
  _hover: {
    borderColor: 'skyBlue',
    _disabled: {
      borderColor: 'neutral.black',
    },
  },
  _focus: {
    borderColor: 'skyBlue',
  },
  _invalid: {
    borderColor: 'red',
  },
  _disabled: {
    cursor: 'default',
  },
});
